import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f65907c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "money" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "left"
}
const _hoisted_6 = {
  key: 1,
  class: "right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" AIPilot产品定价 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_row, { gutter: [20,20] }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.list, (item, index) => {
            return (_openBlock(), _createBlock(_component_a_col, {
              xs: 24,
              md: 12,
              lg: 8
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["item", `i_${index+1}`])
                }, [
                  _createVNode(_component_a_typography_title, { level: 5 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (v) => {
                    return (_openBlock(), _createBlock(_component_a_row, { justify: "between" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { flex: "auto" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(v[0]), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */),
                        _createVNode(_component_a_col, { flex: "auto" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(v[1]), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */))
                  }), 256 /* UNKEYED_FRAGMENT */)),
                  _createElementVNode("div", _hoisted_3, [
                    (item.price)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                          (item.isAbout)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " 约 "))
                            : _createCommentVNode("v-if", true),
                          _createTextVNode(" ¥" + _toDisplayString(item.price) + " ", 1 /* TEXT */),
                          (item.isDiscount)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " 优惠 "))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" 免费部署 ")
                        ], 64 /* STABLE_FRAGMENT */))
                  ])
                ], 2 /* CLASS */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(" 注：托管版费用以云服务器实际定价为准 ")
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}